import { constants, ENROLLMENT_FLOW_TYPES } from './constants'
interface FindEnrollmentFlowTypeProps {
    formType: string
    modification?: string
    missingClientInfo: boolean
}

const findReEnrollmentFlowType = (missingClientInfo: boolean) => {
    return missingClientInfo
        ? ENROLLMENT_FLOW_TYPES.REENROLLMENT_WITH_MOBILE_MONEY_AND_CLIENT_DETAILS
        : ENROLLMENT_FLOW_TYPES.REENROLLMENT_WITH_MOBILE_MONEY
}

export const findEnrollmentFlowType = ({
    formType,
    modification,
    missingClientInfo
}: FindEnrollmentFlowTypeProps) => {
    if (formType === constants.FORM_TYPES.RE_ENROLLMENT) {
        return findReEnrollmentFlowType(missingClientInfo)
    }

    if (modification === constants.CLIENT_MODIFICATION_TYPES.DETAILS) {
        return ENROLLMENT_FLOW_TYPES.CLIENT_MODIFICATION
    }

    if (modification === constants.CLIENT_MODIFICATION_TYPES.PACKAGES) {
        return ENROLLMENT_FLOW_TYPES.PACKAGE_MODIFICATION
    }

    return ENROLLMENT_FLOW_TYPES.ENROLLMENT_WITH_MOBILE_MONEY
}
